import { Button, InputAdornment, Skeleton, Slider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { RowCenterY } from '@/components/common/Rows'
import useBtcFeeSummary from '@/hooks/useBtcFeeSummary'
import { FlexCol } from '@/components/common/Columns'
import NumberInput from '@/components/common/NumberInput'

const MySkeleton = () => {
  return <Skeleton variant="text" sx={{ fontSize: '12px', bgcolor: 'rgba(255,255,255,0.5)' }} />
}

type FeeLevel = 'normal' | 'fast' | 'rapid' | 'custom'

const FeeOptions: { level: FeeLevel; label: string }[] = [
  {
    level: 'normal',
    label: '🚗 Normal',
  },
  {
    level: 'fast',
    label: '✈️ Fast',
  },
  {
    level: 'rapid',
    label: '🚀 Rapid',
  },
  {
    level: 'custom',
    label: 'Custom',
  },
]

const FeeButtonGroup = ({ feeRate, onChange }: { feeRate: string; onChange: (value: string) => void }) => {
  const { data, loading } = useBtcFeeSummary()

  const [feeRateLevel, setFeeRateLevel] = useState<FeeLevel>('normal')

  const handleInputChange = (value: string) => {
    onChange(value)
  }

  useEffect(() => {
    if (feeRateLevel !== 'custom' && !feeRate) {
      onChange('0')
    }
  }, [feeRate, feeRateLevel, onChange])

  useEffect(() => {
    if (feeRateLevel === 'custom') return
    onChange(String(data?.para[feeRateLevel]))
  }, [data, feeRateLevel, onChange])

  return (
    <FlexCol>
      <RowCenterY sx={{ mt: 12, columnGap: 12, height: 60 }}>
        {FeeOptions.map((option) => (
          <Button
            key={option.level}
            variant={feeRateLevel === option.level ? 'contained' : 'outlined'}
            fullWidth
            sx={{ height: '100%' }}
            onClick={() => {
              setFeeRateLevel(option.level)
            }}
          >
            <FlexCol sx={{ rowGap: 4 }}>
              <Typography fontSize={14}>{option.label}</Typography>
              {option.level !== 'custom' ? (
                loading ? (
                  <MySkeleton />
                ) : (
                  <Typography fontSize={14}>{data.para?.[option.level]} sats/vB</Typography>
                )
              ) : null}
            </FlexCol>
          </Button>
        ))}
      </RowCenterY>

      {feeRateLevel === 'custom' && (
        <RowCenterY>
          <NumberInput
            sx={{ width: 131, height: 56, ml: 'auto' }}
            size="small"
            inputProps={{ type: 'text', inputmode: 'numeric', pattern: '[0-9]*' }}
            value={feeRate}
            onUserInput={handleInputChange}
            endAdornment={<InputAdornment position="end">sats/vB</InputAdornment>}
          />
        </RowCenterY>
      )}
    </FlexCol>
  )
}

export default FeeButtonGroup
